{
  const observe = (el, player, playMethod, pauseMethod) => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          player[playMethod]()
        } else {
          player[pauseMethod]()
        }
      })
    }, { threshold: 0 })
    observer.observe(el)
  }

  const loadYTAndObserve = el => {
    const player = new YT.Player(el, {
      events: {
        onReady: () => observe(el, player, 'playVideo', 'pauseVideo')
      }
    })
  }

  const loadVimeoAndObserve = el => {
    const player = new Vimeo.Player(el)
    player.ready().then(() => observe(el, player, 'play', 'pause'))
  }

  const loadNativeVideoAndObserve = el => {
    observe(el, el, 'play', 'pause')
  }

  document.querySelectorAll('.background-video').forEach(el => {
    const src = el.src || el.querySelector('source')?.src || ''

    if (el.tagName === 'IFRAME') {
      if (src.includes("youtube")) {
        window.addEventListener("YouTubeApiReady", () => loadYTAndObserve(el))
      }

      if (src.includes("vimeo")) {
        window.addEventListener("VimeoApiReady", () => loadVimeoAndObserve(el))
      }
    }

    if (el.tagName === 'VIDEO') {
      loadNativeVideoAndObserve(el)
    }
  })
}
